export const ANNUAL_REPORTS_TYPES = {
  // Fetch Annual Reports
  FETCH_ANNUAL_REPORTS_REQUEST: 'FETCH_ANNUAL_REPORTS_REQUEST',
  FETCH_ANNUAL_REPORTS_SUCCESS: 'FETCH_ANNUAL_REPORTS_SUCCESS',
  FETCH_ANNUAL_REPORTS_FAILURE: 'FETCH_ANNUAL_REPORTS_FAILURE',
  
  // Clear Annual Reports
  CLEAR_ANNUAL_REPORTS: 'CLEAR_ANNUAL_REPORTS'
};